<script setup>
defineProps({
    type: {
        type: String,
        default: 'submit',
    },
});
</script>

<template>
    <v-btn :type="type" color="primary">
        <slot />
    </v-btn>
</template>
